import { computed, Ref } from 'vue'
import { useCustomersQuery } from './queries/useCustomersQuery'

export function useCustomer(customerId: Ref<string>) {
   const { data: customers } = useCustomersQuery()

   return computed(() => customers.value?.find((m) => m.id == customerId.value))
}
